import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/reactprojecttypes/';
    const pathsList = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'governanceroom/reactprojecttypes/getall',
        endpointDelete: `${config.endpoints.backend}governanceroom/reactprojecttypes/delete`
    }

    const list = {
        labelTitle: 'Lista de Tipos de Projeto React',
        labelTitleButtonAdd: 'Incluir novo tipo de projeto react',
        fieldsShowOnDelete: ['name'],
        filter: profileFilter,
        canDelete: true,
        columns: [
            {
                name: 'name',
                label: 'Nome'
            },
            {
                name: 'url',
                label: 'URL Técnica'
            }
        ],
        ...pathsList
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;